export default (contact) => {
  if (contact.id) {
    return contact.full_name === 'Unknown' ? contact.email : contact.full_name
  } else {
    return contact.email
  }
}
